'use client';

import etaLoader from '@/lib/EtaLoader';
import { useEffect } from 'react';

export default function CheckSentry() {
  useEffect(() => {
    // Only send Sentry test message once per session
    const hasSentTestMessage = sessionStorage.getItem('sentry_test_sent');
    if (typeof window !== 'undefined' && etaLoader) {
      etaLoader.setContext('global');
      etaLoader.setStage('startingUp', 0);
      console.log('[ETA]🌐 Global context started' );
    }
    if (!hasSentTestMessage && typeof window !== 'undefined' && window.sentry) {
      // Send test message after a delay
      setTimeout(() => {
        try {
          window.sentry.captureMessage(
            `Startup test message from CheckSentry - App initialized successfully`,
            {
              level: 'info',
              tags: {
                component: 'CheckSentry',
                environment: process.env.NODE_ENV || 'development'
              }
            }
          );
          // Mark as sent for this session
          sessionStorage.setItem('sentry_test_sent', 'true');
          console.log('✅ Sentry test message sent successfully');
        } catch (error) {
          console.warn('⚠️ Failed to send Sentry test message:', error);
        }
        if (typeof window !== 'undefined' && etaLoader) {
          etaLoader.setStage('startingUp', 0.4);
        }
      }, 5000); // Reduced delay from 10s to 5s
    }
  }, []);

  return null; // This component doesn't render anything
} 